import React from 'react';

import ReactSelectAsyncSelect from 'react-select/async';
import { components as ReactSelectComponents } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { ValueContainerProps } from 'react-select';

interface Props {
  components?: React.ComponentProps<typeof ReactSelectAsyncSelect>['components'];
  icon?: IconDefinition | false;
}

// A wrapper around react-select's AsyncSelect with Blueprint styling
export function AsyncSelect({
  components = {},
  icon = faSearch,
  ...props
}: Props) {
  return (
    <ReactSelectAsyncSelect
      classNames={{
        control: () => 'form-control',
        menu: () => 'dropdown-menu show',
        placeholder: () => 'text-muted',
        valueContainer: icon ? () => 'ps-6' : '',
      }}
      components={{
        DropdownIndicator: null,
        ValueContainer: icon ? ValueContainerWithIcon : undefined,
        ...components,
      }}
      unstyled
      {...props}

      // icon is a custom prop for ValueContainerWithIcon
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...{ icon } as any}
    />
  );
}

interface ValueContainerWithIconProps extends ValueContainerProps {
  selectProps: ValueContainerProps['selectProps'] & {
    icon: IconDefinition;
  };
}

function ValueContainerWithIcon({ children, selectProps, ...props }: ValueContainerWithIconProps) {
  return (
    <ReactSelectComponents.ValueContainer selectProps={selectProps} {...props}>
      <FontAwesomeIcon
        className="text-primary position-absolute"
        icon={selectProps.icon}
      />
      {children}
    </ReactSelectComponents.ValueContainer>
  );
}
